//import gqmsUtils from '@/qmsUtils';
//let currentDate = gqmsUtils.getGqmsToDate();
import moment from 'moment';

export default {
	isMmcAdmin: false,
	searchParams: SEARCH_PARAMS(),
	torqRgstManagements: [],
	excelDownLoadList: [], //엑셀다운로드시 해더저장
	pagingInfo: PAGING_INFO(),
	selectedRow: SELECTED_ROW()
};

function SEARCH_PARAMS() {
	return {
		startDt: moment().subtract(1, 'years').format('YYYYMMDD'),
		endDt: moment().format('YYYYMMDD'),
		mesEqipNm: '',
		mesEqipNo: ''
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

function SELECTED_ROW() {
	return {
		rowType: '',
		mesDd: '',
		mesTm: '',
		oldMesEqipNo: '',
		newMesEqipNo: '',
		mesEqipNm: '',
		mdlNm: '',
		max2MesNos: '',
		max2MesVal: '',
		max1MesNos: '',
		max1MesVal: '',
		maxMesNos: '',
		maxMesVal: '',
		mesVal: '',
		spcVal: '',
		avgVal: '',
		stdDvatVal: '',
		rsltCd: '',
		rsltNm: '',
		rgnId: '',
		tableState: ''
	};
}

export { SEARCH_PARAMS, PAGING_INFO, SELECTED_ROW };
